export class MeetingEntity {
    id: number;
    subject: string;
    organizerEmail: string;
    startDate: string;
    endDate: string;
    resource: {
        id: number;
        locationId: number;
        locationIds: number[];
        locations: string;
        name: string;
        hasFloorplan: boolean;
        resourceType: string;
    }

    constructor(data?: Partial<MeetingEntity>) {
        this.subject = data?.subject || '';
        this.organizerEmail = data?.organizerEmail || '';
        this.id = data?.id || 0;
        this.startDate = data?.startDate || '';
        this.endDate = data?.endDate || '';
        this.resource = data?.resource || {
            id: 0,
            locationId: 0,
            locationIds: [],
            locations: '',
            name: '',
            hasFloorplan: false,
            resourceType: '',
        };
    }
}
